import { ListingProperties } from "../types/listing.type";
import { EProfileMainEmail, ProfileProperties } from "../types/profile.type";

export function getMainEmailAddress(
	profile: Pick<ProfileProperties, "mainEmail" | "remaxEmail" | "privateEmail">
): string | undefined {
	return profile.mainEmail === EProfileMainEmail.REMAX ? profile.remaxEmail : profile.privateEmail;
}

export function getNotifEmailAddress(profile: Pick<ProfileProperties, "mainEmail" | "remaxEmail" | "privateEmail">) {
	return getMainEmailAddress(profile) ?? profile.privateEmail;
}

export function getEmailPortal(listing: ListingProperties, portalName: "Lamudi" | "Rumah123") {
	// 	4. Tiap listing bsa add email konsep sma kaya yg di agent, perlu handling urutan email dikirim
	// - email portal listing
	// - email portal agent
	// - email default

	let res: string | undefined = "";

	if (
		listing.emailPortals &&
		listing.emailPortals.length > 0 &&
		listing.emailPortals.find((x) => x.portalName === portalName)
	) {
		res = listing?.emailPortals?.find((x) => x.portalName === portalName)?.email;
	} else if (
		listing?.employee?.emailPortals &&
		listing.employee.emailPortals.length > 0 &&
		listing.employee.emailPortals.find((x) => x.portalName === portalName)
	) {
		res = listing.employee.emailPortals.find((x) => x.portalName === portalName)?.email;
	} else {
		res = listing.profile && getMainEmailAddress(listing.profile);
	}

	return res ? res : listing.profile && getMainEmailAddress(listing.profile);
}
